import React, { useEffect, useState } from "react";
import { ShieldAlert, X } from "lucide-react";
import { storageAvailable } from "../lib/safeStorage";

// Non-blocking heads-up shown when the browser blocks storage. The app still
// works this session, but the login/keys won't persist across reloads.
export const StorageBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!storageAvailable()) setShow(true);
  }, []);

  if (!show) return null;

  return (
    <div data-testid="storage-blocked-banner" className="fixed top-0 inset-x-0 z-[100] bg-[#A855F7] text-white px-4 py-2.5 flex items-start gap-3 font-body text-xs">
      <ShieldAlert size={16} className="shrink-0 mt-0.5" />
      <p className="flex-1 leading-relaxed">
        Your browser is blocking secure storage, so you'll be signed out when you reload.
        On <span className="font-semibold">Brave</span>, tap the Shields (lion) icon → set Shields <span className="font-semibold">Down</span> for this site. Avoid Private/Incognito tabs.
      </p>
      <button onClick={() => setShow(false)} data-testid="storage-banner-dismiss" className="shrink-0 hover:opacity-70 transition-opacity">
        <X size={16} />
      </button>
    </div>
  );
};
